import { ExternalUserRegistration } from './external-user-registration';

export class ExternalUserRegistrationState {
  list: ExternalUserRegistration[] = [];

  isUpdating: boolean;
}
